import { useContext, useMemo } from 'react';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';

export const useOdataOptions = (pathOverride = undefined) => {
  const serverContext = useContext(ServerContext);

  const {
    CurrentCustomer: currentCustomer,
    CurrentAccount: currentAccount,
    ServicesEndpoints: { CampaignAPI: host },
    CampaignAPIPath: path,
    Token: token,
    Urls: { SignOutUrl = null } = {},
  } = serverContext;

  const cid = currentAccount ? currentCustomer.Id : '';
  const aid = currentAccount ? currentAccount.Id : '';

  const oDataOption = useMemo(() => ({
    contentType: 'application/json',
    host,
    path: path || pathOverride,
    oDataToken: token,
    SignOutUrl,
  }), [SignOutUrl, host, path, token, pathOverride]);

  const extraFields = useMemo(() => ({ cid, aid }), [aid, cid]);

  return [oDataOption, extraFields];
};
